import React, { useEffect } from 'react';
import {ActionModal, ErrorModal, useErrorHandler} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {AdminModel, useLockUsers} from '../../../../entities';

interface BanAdminModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  admin: AdminModel;
}

export const BanAdminModal = ({open, setOpen, admin}: BanAdminModalProps) => {
  const {lockUserMutation, unlockUserMutation} = useLockUsers({userId: admin.id, setOpen});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Администратор',
    title: 'Ошибка при блокировке администратора',
  });

  useEffect(() => {
    if (lockUserMutation.error) {
      handleError(lockUserMutation.error as unknown as ApiError);
    }
    if (unlockUserMutation.error) {
      handleError(unlockUserMutation.error as unknown as ApiError);
    }
  }, [lockUserMutation.error, unlockUserMutation.error, handleError]);

  const handleSubmit = () => {
    if (admin.lockedAt) {
      unlockUserMutation.mutate(admin.id);
    } else {
      lockUserMutation.mutate(admin.id);
    }
  };

  return (
    <>
    <ActionModal
      open={open}
      onClose={() => setOpen(false)}
      setOpen={() => setOpen(false)}
      submitForm={handleSubmit}
      isLoading={lockUserMutation.isPending}
      size={'s'}
      buttonsSize={'l'}
      caption={admin.lockedAt ? 'Разблокировать' : 'Блокировка администратора'}
      textButtonApply={admin.lockedAt ? 'Разблокировать' : 'Заблокировать'}
      textButtonCancel={'Отменить'}
      viewActionButton="outlined-danger">
      <Text variant="body-2" color="secondary">
        {!admin.lockedAt
          ? 'Вы уверены, что хотите заблокировать этого администратора? После блокировки этот аккаунт потеряет доступ к панели администратора.'
          : 'Вы уверены, что хотите разблокировать этот аккаунт? Аккаунт получит доступ к панели администратора'}
      </Text>
        </ActionModal>
    <ErrorModal
        open={isErrorModalOpen}
        onClose={handleClose}
        title={errorInfo.title}
        message={errorInfo.message}
      />
    </>
  );
};
